import { render, staticRenderFns } from "./CustomerFilter.vue?vue&type=template&id=dd593b5a&scoped=true"
import script from "./CustomerFilter.vue?vue&type=script&lang=js"
export * from "./CustomerFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomerFilter.vue?vue&type=style&index=0&id=dd593b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd593b5a",
  null
  
)

export default component.exports